module.exports = __webpack_public_path__ + "78c42659c9351f0eca333668c0650602.png";